// src/utils/axiosConfig.ts

import axios from 'axios';

const isDevelopment = process.env.NODE_ENV === 'development';

const axiosInstance = axios.create({
  baseURL: isDevelopment ? 'http://localhost' : '',
  headers: isDevelopment
    ? {
        user: 'Local',
      }
    : {},
});

export { axiosInstance, isDevelopment };
